import { format } from 'date-fns'

import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import {
  OnboardingFail,
  OnboardingPartnerFlagServiceMethods,
  OnboardingResponse,
  OnboardingServices,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import {
  IPartnerFlag,
  PartnerFlagRequestAction,
  TPartherFlagRequest,
  TPartnerFlagResponse,
} from '../../models'
import { invalidatePartnerFlagsCache } from '../cache'

export async function updatePartnerFlagRequest(partnerFlag: IPartnerFlag) {
  const currentDate = new Date()
  const isDeleteAction =
    partnerFlag.endDate.setHours(0, 0, 0, 0) <= currentDate.setHours(0, 0, 0, 0)

  let action

  switch (true) {
    case isDeleteAction: {
      action = PartnerFlagRequestAction.Remove
      break
    }
    case !partnerFlag.entryId: {
      action = PartnerFlagRequestAction.Add
      break
    }
    default: {
      action = PartnerFlagRequestAction.Modify
    }
  }

  const payload: TPartherFlagRequest = {
    Action: action,
    Caption: partnerFlag.caption,
    Code: partnerFlag.code,
    CodeName: partnerFlag.codeName,
    Comment: partnerFlag.comment,
    Country: partnerFlag.country,
    EndDate: format(partnerFlag.endDate, 'date'),
    Market: partnerFlag.market,
    PartnerId: partnerFlag.partnerId,
    StartDate: format(partnerFlag.startDate, 'date'),
    Source: ProfilingRequestSource.ClickAndGo,
    Type: partnerFlag.codeType,
  }

  const token = getAccessToken() || ''
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  const response = (await wsClient.call({
    service: OnboardingServices.PartnerFlag,
    action: OnboardingPartnerFlagServiceMethods.Save,
    payload,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
    token,
  })) as OnboardingResponse<OnboardingFail, TPartnerFlagResponse>

  invalidatePartnerFlagsCache(partnerFlag.partnerId)

  return response
}
